import { PointcloudStatus } from '@data-access/geospatial/scan-data';
import { t } from '@trimble/i18n';
import { TreeNodeDefinition } from '@trimble/ui-components/solidjs';
import { UnreachableCaseError } from 'ts-essentials';

export const mapPointCloudStatusToTreeNodeStatus = (
  status: PointcloudStatus
): TreeNodeDefinition['status'] => {
  switch (status) {
    case PointcloudStatus.Processing:
      return {
        status: 'processing',
        disabled: true,
        message: t('mobileMapping.runs.status.processingPointCloud'),
      };
    case PointcloudStatus.Failed:
      return {
        status: 'failed',
        message: t('mobileMapping.runs.status.failedPointCloud'),
      };
    case PointcloudStatus.Ready:
      return undefined;
    default:
      throw new UnreachableCaseError(status);
  }
};
